import observabiltyImg from "public/openStack/k8-observability1.png";

export const EXTEND_CONSTANTS = {
  title: "Extend Your Cloud with OneMind PaaS",
  image: observabiltyImg,
  desc: "MOST integrates tightly with OneMind’s PaaS, giving you a complete ecosystem to build, deploy, monitor, and secure your workloads—with Kubernetes, Observability (Grafana, Elastic), and DevOps toolchains ready to go. ",
};
